import {
  ExportFormat,
  ImageStrokeEffectProps,
  LayerCustomType,
} from "@/custom-fabric";
import { CropSettings } from "./crop-settings";

export interface IImageProps {
  name: string;
  path: string;
  src: string;
}

interface LayerTransformSettings {
  left: number;
  top: number;
  width: number;
  height: number;
  scaleX: number;
  scaleY: number;
  angle: number;
}

interface LayerTypeSettings {
  [key: string]: any;
}

export interface Layer {
  _id: string;
  templateId: string;
  groupId?: string;
  printLayerId?: string;
  functionalId: number;
  customType: LayerCustomType;
  name: string;
  visible: boolean;
  locked: boolean;
  removable: boolean;
  updated: boolean;
  zIndex: number;
  transformSettings: LayerTransformSettings;
  typeSettings: LayerTypeSettings;
}

export interface Group {
  _id: string;
  templateId?: string;
  parentId?: string;
  printGroupId?: string;
  functionalId: number;
  name: string;
  removable?: boolean;
}

export enum TemplateType {
  print = "print",
  preview = "preview",
}

export interface TemplateSettings {
  width: number;
  height: number;
  backgroundColor: string;
  backgroundImagePath?: string;
  libraryItemId?: string | null;
  exportDpi: number;
  exportFormat: ExportFormat;
  exportStrokeEffect?: ImageStrokeEffectProps;
  layers: Layer[];
  groups: Group[];
}

export interface Template {
  _id: string;
  type: TemplateType;
  createdAt: string;
  updatedAt: string;
  artworkId: string;
  name: string;
  thumbnailPath?: string;
  zIndex: number;
  settings: TemplateSettings;
  cropSettings?: CropSettings;
  cropSettingsId?: string | null;
}
